module.exports = __webpack_public_path__ + "f365338718b5ccc01c09f2c544bd1368.svg";